import type { FC } from 'react';

import { CompactActiveAvatarGroup } from '@/shared/components/groups';
import type { TaskAssignee } from '@/types';

interface TaskParticipantAvatarGroupProps {
    maxCount?: number;
    participants: TaskAssignee[];
    size?: number;
}

const TaskParticipantAvatarGroup: FC<TaskParticipantAvatarGroupProps> = ({
    maxCount = 2,
    participants,
    size = 18,
}): JSX.Element | null => {
    if (participants.length === 0) {
        return null;
    }

    return <CompactActiveAvatarGroup collaborators={participants} maxCount={maxCount} size={size} />;
};

export default TaskParticipantAvatarGroup;
